<template>
  <el-container class="home-container">
    <!-- 左侧菜单栏 -->
    <el-aside width="200px">
      <div class="aside_head">睿云</div>
      <!-- 菜单列表 -->
      <el-menu text-color="#333e50" active-text-color="#027aff" :default-active="activePath" @select="handleSelect" unique-opened router :collapse-transition="false">
        <!-- 遍历一级菜单 -->
        <li v-for="child1 in menuList" :key="child1.id">
          <!-- 一级菜单没有子菜单 -->
          <el-menu-item :index="'/' + child1.path" v-if="!child1.childNode">
            <template slot="title">
              <i :class="child1.iconCls"></i>
              <span slot="title">{{ child1.authName }}</span>
            </template>
          </el-menu-item>
          <!-- 一级菜单有子菜单 -->
          <el-submenu :index="'/' + child1.path" v-if="child1.childNode">
            <template slot="title">
              <i :class="child1.iconCls"></i>
              <span slot="title">{{ child1.authName }}</span>
            </template>
            <!-- 遍历二级菜单 -->
            <li v-for="child2 in child1.childNode" :key="child2.id">
              <!-- 二级菜单没有子菜单 -->
              <el-menu-item :index="'/' + child2.path" v-if="!child2.childNode">
                <template slot="title">
                  <!-- <i class="el-icon-caret-right"></i> -->
                  <i :class="child2.iconCls"></i>
                  <span slot="title">{{ child2.authName }}</span>
                </template>
              </el-menu-item>
              <!-- 二级菜单有子菜单 -->
              <el-submenu :index="'/' + child2.path" v-if="child2.childNode">
                <template slot="title">
                  <!-- <i class="el-icon-caret-right"></i> -->
                  <i :class="child2.iconCls"></i>
                  <span slot="title">{{ child2.authName }}</span>
                </template>
                <!-- 遍历三级菜单 -->
                <li v-for="child3 in child2.childNode" :key="child3.id">
                  <!-- 三级菜单没有子菜单 -->
                  <el-menu-item :index="'/' + child3.path">
                    <template slot="title">
                      <!-- <i class="el-icon-caret-right"></i> -->
                      <i :class="child3.iconCls"></i>
                      <span slot="title">{{ child3.authName }}</span>
                    </template>
                  </el-menu-item>
                </li>
              </el-submenu>
            </li>
          </el-submenu>
        </li>
      </el-menu>
    </el-aside>
    <!-- 左侧菜单栏 结束 -->

    <!-- 右侧主题内容 -->
    <el-container>
      <!-- 头部 -->
      <el-header>
        <div class="toggle_btn" @click="toggleCollpse">
          <i class="el-icon-s-fold"></i>
        </div>
        <div class="user_info">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              欢迎，
              <span>{{Nicename}}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changeacount">切换身份</el-dropdown-item>
              <el-dropdown-item command="editpassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="quit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <!-- 头部 结束 -->

      <el-main :style="defaultHeight">
        <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab" class="mytabs">
          <el-tab-pane
            v-for="item in editableTabs"
            :key="item.name"
            :label="item.title"
            :name="item.name"
          >
          </el-tab-pane>
        </el-tabs>
      </el-main>

      <!-- 主要内容区 -->
      <el-main>
        <!-- <transition> -->
          <keep-alive :include="myKeepList">
            <router-view></router-view>
          </keep-alive>
        <!-- </transition> -->
      </el-main>
      <!-- 主要内容区 结束 -->
    </el-container>

    <!-- 切换身份 -->
    <el-dialog title="切换身份" :visible.sync="changeAcountDialog" width="30%" :show-close="false">
      <div v-for="item in acountList" :key="item.Useriderp">
        <el-button type="text" size="medium" style="margin-left: 0; margin-right: 5px" @click="cilckChangeAcount(item)">{{item.Nicename}}</el-button>
      </div>
    </el-dialog>
    <!-- 切换身份 end -->

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="editUserInfo" width="30%" :show-close="false">
      <el-form :model="editAaminForm" ref="editAaminFormRef" label-width="70px">
        <el-form-item label="旧密码" class="addAdminForm">
          <el-input v-model="editAaminForm.oldpassword" type="password" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" class="addAdminForm">
          <el-input v-model="editAaminForm.newpassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改密码 end -->

  </el-container>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      defaultHeight: {
        height: '100px'
      },
      changeAcountDialog: false,
      editUserInfo: false,
      Nicename: '',
      // 被激活的链接地址
      activePath: '',
      editAaminForm: {
        oldpassword: '',
        newpassword: ''
      },
      // 菜单分类数据
      menuList: [],
      menuListdata: [],
      editableTabs: [],
      editableTabsValue: '',
      myKeepList: [],
      acountList: []
    }
  },
  created () {
    var that = this
    var Employeestype = localStorage.getItem('Employeestype')
    var Jigouidneibu = localStorage.getItem('Jigouidneibu')
    if (Employeestype === '1') {
      if (Jigouidneibu === '1') {
        this.$router.push('/HomeForLeader')
        this.activePath = '/HomeForLeader'
        this.editableTabs = [{ title: '快速导航', name: '/HomeForLeader' }]
        this.editableTabsValue = '/HomeForLeader'
      } else {
        this.$router.push('/HomeForEmployees')
        this.activePath = '/HomeForEmployees'
        this.editableTabs = [{ title: '员工首页', name: '/HomeForEmployees' }]
        this.editableTabsValue = '/HomeForEmployees'
      }
    } else {
      this.$router.push('/HomePage')
      this.activePath = '/HomePage'
      this.editableTabs = [{ title: '数据展示', name: '/HomePage' }]
      this.editableTabsValue = '/HomePage'
    }
    this.$data.Nicename = localStorage.getItem('Nicename')
    this.apigetprivatemenu()

    Event.$on('clickQuickNavigation', function (menuname, key) {
      that.addTab(menuname, key)
      that.$router.push(key)
      that.activePath = key
    })

    this.SystemSetAdminsGetMyAcounts()

    //判断是否需要跳转
    var gotopath = localStorage.getItem('gotopath')
    var gotopathname = localStorage.getItem('gotopathname')
    if(gotopath != ""){
      setTimeout(function () {
        localStorage.setItem("gotopath","");
        localStorage.setItem("gotopathname","");

        that.$router.push(gotopath)
        that.activePath = gotopath
        that.editableTabs = [{ title: gotopathname, name: gotopath }]
        that.editableTabsValue = gotopath
      }, 1000)
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      var menuname = this.getMenuName(key)
      this.addTab(menuname, key)
    },
    toggleCollpse () {
    },
    handleCommand (command) {
      if (command === 'quit') {
        this.clickquit()
      } else if(command === 'changeacount') {
        this.changeAcountDialog = true
      } else {
        this.editUserInfo = true
      }
    },
    getMenuName (path) {
      var pathsrc = path.substring(1)
      var authname = ''
      this.menuListdata.filter((item1, i1) => {
        item1.List.filter((item2, i2) => {
          item2.List.filter((item3, i3) => {
            if (item3.Path === pathsrc) {
              authname = item3.Authname
            }
          })
          if (item2.Path === pathsrc) {
            authname = item2.Authname
          }
        })
        if (item1.Path === pathsrc) {
          authname = item1.Authname
        }
      })
      return authname
    },
    removeTab (targetName) {
      const tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.$router.push(activeName)
      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter(tab => tab.name !== targetName)

      const buflist = this.myKeepList
      var newname = targetName.replace('/', 'My')
      this.myKeepList = buflist.filter(buf => buf !== newname)
    },
    addTab (title, name) {
      var newtab = true
      this.editableTabs.forEach((tab, index) => {
        if (tab.name === name) {
          newtab = false
        }
      })

      if (newtab) {
        this.editableTabs.push({
          title: title,
          name: name
        })

        var newname = name.replace('/', 'My')
        this.myKeepList.push(newname)
      }
      this.editableTabsValue = name
    },
    clickTab (tab) {
      this.$router.push(tab.name)
    },
    clickquit () {
      var that = this
      this.$confirm('您确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确定
        // 清空数据
        localStorage.setItem('Useriderp', '')
        localStorage.setItem('Nicename', '')
        localStorage.setItem('Authtokenerp', '')
        localStorage.setItem('LocalFingerprint', '')
        // 跳转
        that.$router.push('/Login')
      }).catch(() => {
        // 取消
      })
    },
    clicksave () {
      if (!this.editAaminForm.oldpassword) {
        this.$alert('请输入旧密码', '提示')
        return
      }
      if (!this.editAaminForm.newpassword) {
        this.$alert('请输入新密码', '提示')
        return
      }
      this.apieditselfpwd()
    },
    cilckChangeAcount(item){
      console.log(item)
      // 保存数据
      localStorage.setItem('Useriderp', item.Useriderp)
      localStorage.setItem('Nicename', item.Nicename)
      localStorage.setItem('Employeestype', item.Employeestype)
      localStorage.setItem('Jigouidneibu', item.Jigouidneibu)
      // 跳转
      this.changeAcountDialog = false
      this.$router.replace('/Home')
      setTimeout(function () {
        location.reload()
      }, 500)
    },
    apigetprivatemenu: function (roleid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getprivatemenu, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.menuList = []
            that.menuListdata = response.data.List
            response.data.List.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  list3.push({ id: item3.Id, authName: item3.Authname, path: item3.Path, iconCls: item3.Iconcls, childNode: '' })
                })
                if (list3.length === 0) list3 = ''
                list2.push({ id: item2.Id, authName: item2.Authname, path: item2.Path, iconCls: item2.Iconcls, childNode: list3 })
              })
              if (list2.length === 0) list2 = ''
              that.menuList.push({ id: item1.Id, authName: item1.Authname, path: item1.Path, iconCls: item1.Iconcls, childNode: list2 })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditselfpwd: function () {
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        oldpassword: this.editAaminForm.oldpassword,
        newpassword: this.editAaminForm.newpassword
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editselfpwd, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    SystemSetAdminsGetMyAcounts: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_SystemSetAdminsGetMyAcounts, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.acountList = response.data.List
            // console.log(that.acountList)
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.aside_head {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background: linear-gradient(left, #00a9e9, #027aff);
  background: -webkit-linear-gradient(left, #00a9e9, #027aff);
}
.el-menu {
  border-right: 0;
}
.el-aside {
  position: relative;
  box-shadow: 5px 0px 5px -5px #d5d5d5;
}
.el-aside::-webkit-scrollbar {
  display: none;
}
.el-header {
  z-index: 10;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 5px 5px -5px #d5d5d5;
  .toggle_btn {
    font-size: 26px;
    cursor: pointer;
    color: #b4b2bf;
    z-index: 99;
  }
}
.el-dropdown-link span {
  color: #027aff;
}
</style>

<style>
  .mytabs .el-tabs__item {
    color: #ffffff;
    background: #478FCA;
  }
  .mytabs .el-tabs__item.is-active {
    color: #18ffec;
    background: #478FCA;
  }
</style>
